<template>
  <div class="main-center" ref="middle">
    <img src="@/assets/img/driver2.png" style="width: 100%" alt="">
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { isIEBrowser } from '@/utils'
export default {
  components: {

  },
  data() {
    return {
      img:false,
    };
  },
  filters: {

  },
  created() {

  },
  activated() {

  },
  mounted() {

  },
  deactivated() {

  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>


</style>
